
      export default {
        mounted() {
          // Die drei Zonen aendern ihre Hoehe ohne Zutun von LiveView: ein Menue
          // klappt auf, eine Zeile bricht um, die Tastatur schiebt das Fenster.
          // Ein `ResizeObserver` sieht alles davon, `updated()` nur das Erste.
          this.zones = [["#pet-dock", "--dock-h"], [".pet-top", "--top-h"], [".pet-notes", "--notes-h"]]
          // Die Leiste ueber eine neue Version steht ausserhalb des Screens
          // (sie kommt aus `Layouts.app`), liegt auf dem Handy aber in
          // derselben Zone — also wird sie mitgemessen. Ohne sie ist die
          // Zone 0 hoch, und der Kopf rueckt nach oben.
          this.bar = () => document.querySelector(".new-version-bar")
          this.observer = new ResizeObserver(() => this.sync())
          this.observe()
          this.sync()
        },

        updated() {
          this.observe()
          this.sync()
        },

        destroyed() {
          this.observer.disconnect()
        },

        observe() {
          this.observer.disconnect()
          for (const [selector] of this.zones) {
            const el = this.el.querySelector(selector)
            if (el) this.observer.observe(el)
          }
          const bar = this.bar()
          if (bar) this.observer.observe(bar)
        },

        sync() {
          for (const [selector, name] of this.zones) {
            const el = this.el.querySelector(selector)
            const h = el ? Math.round(el.getBoundingClientRect().height) : 0
            this.el.style.setProperty(name, `${h}px`)
          }
          const bar = this.bar()
          const barH = bar ? Math.round(bar.getBoundingClientRect().height) + 8 : 0
          this.el.style.setProperty("--notice-h", `${barH}px`)
        }
      }
    